

import { useState } from "react";
import { useQuery } from "@tanstack/react-query";
import { CourseListResponse, getCourses } from "../../../../api/courses";

interface UseCBTListParams {
  initialPage?: number;
  initialLimit?: number;
  isAdmin?: boolean;
}

export const useCBTList = ({
  initialPage = 1,
  initialLimit = 10,
  isAdmin = true,
}: UseCBTListParams) => {
  const [page, setPage] = useState(initialPage);
  const [limit] = useState(initialLimit);

  const responseQuery = useQuery<CourseListResponse>({
    queryKey: ["admin-cbt", { page, limit }],
    queryFn: () => getCourses({ page, limit, type: 'CBT' }, isAdmin),
  });

  const onPaginationChange = (pagination: { current: number; pageSize: number }) => {
    setPage(pagination.current);
  };

  return {
    ...responseQuery,
    page,
    limit,
    onPaginationChange,
  };
};